import { createContext } from "react";
export const applicationContext = createContext(null);